import LiftCloseSaleAction from "./LiftCloseSaleAction";
import {useState,useContext} from "react";
import {LiftCrmClientContext} from "./LiftCrmClientActions";
import {confirmedBindingForCard} from "./liftCardBinding.mjs";

// Sale is a command, not an optimistic stage edit. Only the persisted LIFT
// response may change the controlled value; dismissing the picker writes nothing.
export default function LiftSaleStageSelect({
  moduleId,record,value,onChange,options,saleStage,onLinked,onBegin,onSettled,
  disabled=false,style,onClick,id,defaultValue,"aria-label":ariaLabel="Etapa",
}){
  const [draft,setDraft]=useState(defaultValue||"");
  const context=useContext(LiftCrmClientContext);
  const binding=confirmedBindingForCard(moduleId,record,context?.sales||[]);
  const [confirmed,setConfirmed]=useState(null);
  const identity=`${moduleId}:${record?._rawPhone||record?.id}`;
  const currentValue=value===undefined?draft:value;
  const waitingForParent=confirmed?.identity===identity
    && !(Date.parse(record?.updatedAt)>Date.parse(confirmed.at));
  const selectedValue=binding?saleStage:waitingForParent?confirmed.stage:currentValue;
  const stages=options.some(stage=>stage.id===saleStage)?options:[...options,{id:saleStage}];
  return <LiftCloseSaleAction moduleId={moduleId} record={record}
    onBegin={onBegin} onSettled={onSettled}
    onLinked={card=>{
      setConfirmed({identity,stage:saleStage,at:card.updatedAt});setDraft(saleStage);
      onLinked?.(card);
    }}
    renderTrigger={({openPicker,busy,canLink})=><select
      id={id} aria-label={ariaLabel} value={selectedValue||""} disabled={disabled||busy} onClick={onClick}
      style={{width:"100%",...style}}
      onChange={event=>{
        if(event.target.value===saleStage){openPicker();return;}
        setConfirmed(null);setDraft(event.target.value);onChange?.(event.target.value);
      }}>
      {stages.map(stage=><option key={stage.id} value={stage.id}
        disabled={stage.id===saleStage&&!canLink}>
        {stage.id===saleStage?"Fechou venda":`${stage.icon?`${stage.icon} `:""}${stage.label}`}
      </option>)}
    </select>}/>;
}
